export const {
  IS_DEV,
  BASE_URL,
  VITE_HEKA_PROXY: HEKA_PROXY,
} = import.meta.env;
